import React, { Component } from "react";
import { Image, Divider } from "semantic-ui-react";
import InstagramEmbed from "react-instagram-embed";
const style = {
  rounded: {
    borderRadius: "5px"
  }
};
const EmbedInstagram = () => (
  <InstagramEmbed
    url="https://www.instagram.com/p/BqqhyuEFjNw/"
    hideCaption={false}
    containerTagName="div"
    protocol=""
    injectScript
  />
);
const imageList = [
  "https://lh3.googleusercontent.com/5HI7CovkCWn-qnjtqPaX95J98FbXeu_5VKYknf1oHhuQDqJUgFqYFs6DXOQ6DraPxkKALOj9niUFnKjUf39DI1fee9XTNSAjP1b9MQAIB9aaM7t2HmmHrleUGfTnxNN5E_PWzrVdFA=h500",
  "https://c1.staticflickr.com/7/6125/5939305926_fcf66f00a0_b.jpg",
  "https://c1.staticflickr.com/6/5313/5800215149_3e285f3f85_b.jpg",
  "https://c1.staticflickr.com/3/2657/5800088487_e125743e07_b.jpg",
  "https://c1.staticflickr.com/3/2107/5768377685_19bba78411_b.jpg",
  "https://c1.staticflickr.com/3/2059/5735840286_ea2b077cdd_b.jpg"
];
export default class StuffList extends Component {
  render() {
    return (
      <div>
        {/* Photo or gallery section */}
        <Divider horizontal>Snaps</Divider>
        <Image.Group>
          {imageList.map((url, i) => {
            return <Image fluid style={style.rounded} src={url} key={i} />;
          })}
        </Image.Group>
        {/* Twitch section */}
        <Divider horizontal>Twitch</Divider>
        <div className="iframe-container iframe-container-16by9">
          <iframe
            title="Stream video"
            src="https://player.twitch.tv/?channel=gopal_virtual"
            frameBorder="0"
            allowFullScreen
            scrolling="no"
          />
        </div>
        {/* Sketch section */}
        <Divider horizontal>Sketches</Divider>
        <EmbedInstagram />
        {/* Tutorial section */}
        <Divider horizontal>Vlog</Divider>
        <div className="iframe-container iframe-container-16by9">
          <iframe
            title="Tutorial video"
            src="https://www.youtube.com/embed/LexGNYAuog8?enablejsapi=1"
            frameBorder="0"
            allowFullScreen
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/StuffList.js